module.exports = __webpack_public_path__ + "static/media/EC.91a59e5e.png";